'use client';

import { AccountNotFound } from '@ahamove/icons';
import { Button, Group, Modal, Stack, Text, Title, rem } from '@mantine/core';
import type { Locales } from '../locales';
import { actionsLocales } from '../locales/actions';
import { authLocales } from '../locales/auth';
import createTranslations from '../locales/createTranslations';

export interface UserNotFoundModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  phoneNumber: string;
  lang?: keyof Locales;
}

export default function UserNotFoundModal({
  opened,
  onClose,
  onConfirm,
  phoneNumber,
  lang = 'vi',
}: UserNotFoundModalProps) {
  // const tAuth = useTranslations('system.auth');
  // const tActions = useTranslations('common.actions');
  const tAuth = createTranslations({ locales: authLocales, lang });
  const tActions = createTranslations({ locales: actionsLocales, lang });
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="sm"
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      overlayProps={{
        backgroundOpacity: 0.55 / 2,
      }}
      styles={{
        overlay: {
          zIndex: 1500,
        },
        inner: {
          zIndex: 1500,
        },
      }}
    >
      <Stack align="center" gap={rem(8)} mt="md">
        <AccountNotFound
          width={208}
          height={158}
          style={{ marginBottom: rem(16) }}
        />
        <Title order={3} ta="center" c="neutral.6">
          {tAuth('thisAccountDoesNotExist')}
        </Title>
        <Text size="sm" ta="center" c="neutral.6" fw={500}>
          {tAuth('thisAccountDoesNotExistHintPhoneNumber')}{' '}
          <Text size="sm" fw={600} component="strong" c="neutral.6">
            +{phoneNumber}
          </Text>{' '}
          {tAuth('thisAccountDoesNotExistHintQuestion')}
        </Text>
      </Stack>

      <Group mt={rem(32)} gap={rem(12)} wrap="nowrap">
        <Button fullWidth h={rem(48)} variant="default" onClick={onClose}>
          {tActions('close')}
        </Button>
        <Button fullWidth h={rem(48)} onClick={onConfirm}>
          {tAuth('signUp')}
        </Button>
      </Group>
    </Modal>
  );
}
